var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPromote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#7C7C7C",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/export"
  }, /*#__PURE__*/React.createElement("g", {
    id: "export"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833252 7.99967C0.833252 4.04353 4.04378 0.833008 7.99992 0.833008C8.27606 0.833008 8.49992 1.05687 8.49992 1.33301C8.49992 1.60915 8.27606 1.83301 7.99992 1.83301C4.59606 1.83301 1.83325 4.59582 1.83325 7.99967C1.83325 11.4035 4.59606 14.1663 7.99992 14.1663C11.4038 14.1663 14.1666 11.4035 14.1666 7.99967C14.1666 7.72353 14.3904 7.49967 14.6666 7.49967C14.9427 7.49967 15.1666 7.72353 15.1666 7.99967C15.1666 11.9558 11.9561 15.1663 7.99992 15.1663C4.04378 15.1663 0.833252 11.9558 0.833252 7.99967Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4867 1.51266C14.682 1.70792 14.682 2.0245 14.4867 2.21976L9.02006 7.68643C8.8248 7.88169 8.50821 7.88169 8.31295 7.68643C8.11769 7.49117 8.11769 7.17459 8.31295 6.97932L13.7796 1.51266C13.9749 1.3174 14.2915 1.3174 14.4867 1.51266Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9465 1.33301C10.9465 1.05687 11.1704 0.833008 11.4465 0.833008H14.6665C14.9427 0.833008 15.1665 1.05687 15.1665 1.33301V4.55301C15.1665 4.82915 14.9427 5.05301 14.6665 5.05301C14.3904 5.05301 14.1665 4.82915 14.1665 4.55301V1.83301H11.4465C11.1704 1.83301 10.9465 1.60915 10.9465 1.33301Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromote);
export default __webpack_public_path__ + "static/media/promote.a646fe6eda853e7762c8209bc55288d0.svg";
export { ForwardRef as ReactComponent };